import React from 'react'
import { Card } from "react-bootstrap"
import TimelineTab from './TimelineTab'
import DetailTab from './DetailTab'
import ActivityTab from './ActivityTab'
import DocumentTab from './DocumentTab'
import BookingTabs from './BookingTabs'
import Const from '../../../util/Constants'
import Util from '../../../util/Util'

const MainContentTabs = ({
  activeTab,
  onTabChange,
  lead,
  ...props
}) => {

  const tabs = [
    { id: "timeline", label: "Timeline", permission: true },
    { id: "detail", label: "Detail", permission: true },
    { id: "activity", label: "Activity", permission: true },
    { id: "document", label: props.model.document.model_name, permission: Util.isAllow(props.model.document.permission, Const.PermView)},
    { id: "booking", label: props.model.sales_order.model_name, permission: Util.isAllow(props.model.sales_order.permission, Const.PermView)}
  ]

  const renderTabContent = () => {
    switch (activeTab) {
      case "timeline":
        return <TimelineTab
          // {...this.props}
          id={lead.id}
          type={Const.Lead}
          lead={lead}
          model={props.model}
          cloud_call={props.cloud_call}
          edit={props.edit}
          show={props.show}
          reload={props.reload}
        />
      case "detail":
        return <DetailTab 
          id={lead.id}
          type={Const.Lead}
          lead={lead}
          model={props.model.lead}
          cloud_call={props.cloud_call}
          edit={props.edit}
          show={props.show}
          reload={props.reload}
        />
      case "activity":
        return <ActivityTab 
          id={lead.id}
          type={Const.Lead}
          lead={lead}
          model={props.model}
          cloud_call={props.cloud_call}
          edit={props.edit}
          show={props.show}
          reload={props.reload}
        />
      case "document":
        return <DocumentTab 
          id={lead.id}
          type={Const.Lead}
          lead={lead}
          model={props.model}
          cloud_call={props.cloud_call}
          edit={props.edit} 
          show={props.show}
          reload={props.reload}
        />
      case "booking":
        return <BookingTabs 
          id={lead.id}
          type={Const.Lead}
          lead={lead}
          model={props.model}
          cloud_call={props.cloud_call}
          edit={props.edit} 
          show={props.show}
          reload={props.reload}
        />
      default:  
    }
  }

  return (
    <Card
      style={{
        backgroundColor: 'white',
        border: '1px solid #e5e7eb',
        borderRadius: '8px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
        height: '100%',
        overflow: 'hidden'
      }}
    >
      {/* Tabs Header */}
      <div
        style={{
          display: 'flex',
          borderBottom: '1px solid #e5e7eb',
          overflowX: 'auto',
          backgroundColor: 'white'
        }}
      >
        {tabs.map(tab => (
          tab.permission ? <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            style={{
              flex: 1,
              padding: '10px 14px', // 🔽 reduced
              fontSize: '13px',     // 🔽 slightly smaller
              fontWeight: 500,
              whiteSpace: 'nowrap',
              border: 'none',
              backgroundColor: activeTab === tab.id ? '#eff6ff' : 'transparent',
              color: activeTab === tab.id ? '#1d4ed8' : '#4b5563',
              borderBottom: activeTab === tab.id ? '2px solid #2563eb' : '2px solid transparent',
              cursor: 'pointer'
            }}
          >
            {tab.label}
          </button> : null
        ))}
      </div>

      {/* Tab Content */}
      <div
        style={{
          padding: '16px',      // 🔽 reduced from 24px
          maxHeight: '720px',   // 🔽 slightly tighter
          overflowY: 'auto'
        }}
      >
        {renderTabContent()}
      </div>
    </Card>
  )
}

export default MainContentTabs
